import { AI_CHAT_ACTOR_NAME } from "@productlane/lib/src/ai-chat-sync"

import { getContactDisplayName } from "@/lib/email-utils"

// The widget chat saved the agent as "AI Agent" from 2026-07-24 to 2026-08-06.
const AGENT_ACTOR_NAMES = new Set([AI_CHAT_ACTOR_NAME, "AI Agent"])

export function isAgentActorName(actorName: string | null | undefined) {
	return !!actorName && AGENT_ACTOR_NAMES.has(actorName)
}

// AI chat and the portal bake `contact.name || contact.email` into actorName at
// write time, so a contact who was anonymous or unnamed back then leaves an
// email address or the "User" placeholder on every message they sent.
const ACTOR_NAME_PLACEHOLDERS = new Set(["user", "anonymous", "unknown"])

export function resolveThreadActorName(
	actorName: string | null | undefined,
	contact?: { name?: string | null; email?: string | null } | null,
): string | undefined {
	const contactName = contact
		? getContactDisplayName(contact)?.trim()
		: undefined
	if (contactName) return contactName

	const actor = actorName?.trim()
	if (!actor || ACTOR_NAME_PLACEHOLDERS.has(actor.toLowerCase()))
		return undefined
	if (actor.includes("@")) return getContactDisplayName({ email: actor })
	return actor
}
